// frontend/admin-portal/src/services/profileService.js
import api from './axiosConfig';

export const profileService = {
    getMe: async () => {
        const { data } = await api.get('/users/me');
        return data.data.user;
    },
    updateMe: async (payload) => {
        const { data } = await api.put('/users/me', payload);
        return data.data.user;
    },
    changePassword: async (currentPassword, newPassword) => {
        const { data } = await api.put('/users/me/password', {
            currentPassword,
            newPassword,
        });
        return data;
    },
    listSessions: async () => {
        const { data } = await api.get('/auth/sessions');
        return data.data.sessions;
    },
    revokeSession: async (id) => {
        const { data } = await api.delete(`/auth/sessions/${id}`);
        return data;
    },
    revokeOtherSessions: async () => {
        const { data } = await api.delete('/auth/sessions');
        return data;
    },
};